import { buildWalletAvatarModel } from "../lib/userAvatar";

export function UserAvatar({ walletAddress, className = "", size = "md" }) {
  const model = buildWalletAvatarModel(walletAddress);
  const sizeClass = size === "sm" ? "h-9 w-9 text-xs" : "h-11 w-11 text-sm";

  return (
    <span
      className={[
        "inline-flex shrink-0 items-center justify-center rounded-full border border-zinc-700 font-semibold shadow-[inset_0_1px_0_rgba(255,255,255,.12)]",
        sizeClass,
        className
      ].join(" ").trim()}
      style={{
        backgroundColor: model.backgroundColor,
        color: model.foregroundColor
      }}
      aria-hidden="true"
    >
      {model.label}
    </span>
  );
}
